<template>
  <sc-page-base
    :loading="loading"
    :title="title">
    <sc-tabs
      v-model="activeTab"
      @change="changeTabs"
      type="is-boxed has-form">
      <sc-tab-item label="Por volume">
				<sc-quote-freight-by-volume/>
			</sc-tab-item>
      <sc-tab-item label="Por produto">
        <sc-quote-freight-by-product/>
      </sc-tab-item>
      <sc-tab-item label="Simulação de cotação">
        <sc-logistic-draft-test v-if="activeTab === 2"></sc-logistic-draft-test>
      </sc-tab-item>
    </sc-tabs>
  </sc-page-base>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
  ScPageBase,
  ScTabs,
  ScTabItem,
} from '@intelipost-js/secure-components';
import ScQuoteFreightByVolume from './components/sc-quote-freight-by-volume/ScQuoteFreightByVolume';
import ScQuoteFreightByProduct from './components/sc-quote-freight-by-product/ScQuoteFreightByProduct';
import ScLogisticDraft from './components/sc-logistic-draft/ScLogisticDraft';
import ScLogisticDraftTest from './components/sc-logistic-draft-test/ScLogisticDraftTest';

const {
  mapState,
} = createNamespacedHelpers('quote/freightQuote');
export default {
  name: 'page-freight-quote',
  data() {
    return {
      activeTab: 0,
    };
  },
  computed: {
    title() {
      return 'Cotação de Frete';
    },
    ...mapState([
      'loading',
      'logistic_contract_mode',
    ]),
  },
  methods: {
    changeTabs() {
      const quoteFreight = {
        excluded_methods: [],
        logistic_provider: {
          delivery_methods: [],
        },
        order: {
          qty_volumes: null,
        },
      };
      return this.$store.commit('quote/freightQuote/setquoteFreight', Object.assign({}, quoteFreight));
    },
  },
  components: {
    ScPageBase,
    ScTabs,
    ScTabItem,
    ScQuoteFreightByVolume,
    ScQuoteFreightByProduct,
    ScLogisticDraft,
    ScLogisticDraftTest,
  },
};
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-quote/features/freight-quote/PageFreightQuote.vue?b7d1d9b2